export default function Hero() {
  const stats = [
    { label: '热播剧集', value: '20,000+', icon: 'ri-movie-2-line' },
    { label: '每日更新', value: '300+', icon: 'ri-refresh-line' },
    { label: '流畅播放', value: '99.9%', icon: 'ri-speed-up-line' },
  ];

  return (
    <section
      id="hero"
      className="relative min-h-[620px] md:min-h-[700px] flex items-center overflow-hidden pt-[72px]"
    >
      {/* Background image with overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20abstract%20background%20with%20soft%20warm%20amber%20and%20deep%20navy%20gradients%2C%20subtle%20film%20grain%20texture%2C%20atmospheric%20light%20rays%20from%20top%20corner%2C%20no%20text%20or%20logos%2C%20smooth%20bokeh%20effects%2C%20elegant%20theater%20ambiance%2C%20dark%20moody%20cinematic%20tone%2C%20professional%20film%20industry%20aesthetic&width=1800&height=900&seq=hero-bg-cinema-01&orientation=landscape"
          alt="极速影视背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-background-50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* Left column - text */}
          <div className="flex-1 w-full text-center lg:text-left">
            {/* Tag */}
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/15 border border-primary-500/30 mb-6">
              <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
              <span className="text-xs font-medium text-primary-400 whitespace-nowrap">正在热播中</span>
            </div>

            {/* H1 - 站点名称 + 核心定位 */}
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-50 leading-tight mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
              极速影视
              <span className="block text-2xl md:text-3xl lg:text-4xl text-foreground-200 font-normal mt-2">
                高清秒播·追剧不等待
              </span>
            </h1>

            {/* Intro paragraph */}
            <p className="text-foreground-400 text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              极速影视平台汇聚海量正版影视资源，采用新一代智能分发加速技术，实现秒开即播的流畅观影体验。
              每日同步更新热播剧集与院线大片，覆盖国产、日韩、欧美等主流频道，随时随地打开就看的追剧神器。
              当前站内热播剧集超过两万部，涵盖都市情感、古装悬疑、热血动漫、综艺纪录等全品类内容。
            </p>

            {/* Stats */}
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mb-8">
              {stats.map((stat) => (
                <div key={stat.label} className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-lg bg-background-200/70 flex items-center justify-center">
                    <i className={`${stat.icon} text-accent-500 text-lg`}></i>
                  </div>
                  <div className="text-left">
                    <div className="text-lg md:text-xl font-bold text-foreground-50 whitespace-nowrap" style={{ fontFamily: 'var(--font-heading)' }}>
                      {stat.value}
                    </div>
                    <div className="text-xs text-foreground-500 whitespace-nowrap">{stat.label}</div>
                  </div>
                </div>
              ))}
            </div>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#media"
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-foreground-50 font-semibold rounded-lg transition-all duration-200 text-sm whitespace-nowrap cursor-pointer no-underline"
              >
                <i className="ri-play-circle-fill text-lg"></i>
                立即追剧
              </a>
              <a
                href="#app"
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-background-200/80 hover:bg-background-300/80 text-foreground-100 font-medium rounded-lg transition-all duration-200 text-sm whitespace-nowrap cursor-pointer no-underline border border-background-300/50"
              >
                <i className="ri-smartphone-line text-lg"></i>
                下载手机版
              </a>
            </div>
          </div>

          {/* Right column - visual */}
          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-primary-500/10 rounded-2xl blur-2xl"></div>
              <div className="relative rounded-2xl overflow-hidden border border-background-200/50">
                <img
                  src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20streaming%20visual%20with%20warm%20amber%20lighting%2C%20abstract%20film%20strip%20elements%2C%20modern%20digital%20entertainment%20aesthetic%2C%20dark%20background%20with%20glowing%20accents%2C%20elegant%20composition%2C%20professional%20broadcast%20quality%2C%20no%20text%20or%20logos%2C%20atmospheric%20and%20immersive%20mood&width=800&height=1000&seq=hero-visual-01&orientation=portrait"
                  alt="极速影视观影体验"
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}